import * as Sentry from '@sentry/vue';

export const sentryReplaysForUsers = async (user, isSreplay = false) => {
  const replay = Sentry.getReplay();
  if (replay.getReplayId()) {
    // Для 10% авторизованных пользователей отправляем
    // накопленные данные несмотря на то,
    // была ли ошибка и продолжаем запись
    if (user && user.email && Math.random() <= 0.1) {
      await replay.flush();
    } else {
      // для остальных пользователей останавливаем реплаи
      await replay.stop();
    }
  }

  if ((user && user.email) || isSreplay) {
    Sentry.setUser({ email: user?.email });
    // Если реплай не записывается, то запускаем буферизацию
    // либо он продолжает запись из-за flush выше
    if (!replay.getReplayId()) {
      replay.startBuffering();
    }
  }

  if (!user || !user.email) {
    Sentry.setUser(null);
  }
};
